import { useContext } from 'react'
import { Context as RenderSchemaContext } from './renderSchema/Context'

const useRenderSchema = () => {
  const { renderSchema } = useContext(RenderSchemaContext)
  return renderSchema
}

export default useRenderSchema
